// material-ui
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import { Autocomplete, TextField } from '@mui/material';
import { useUserContext } from '../../../../contexts/UserContext';
import { useNavigate } from 'react-router';

// ==============================|| HEADER CONTENT - SEARCH ||============================== //

export default function Search() {
  const { user, selectedVenue, setSelectedVenue } = useUserContext();
  const navigate = useNavigate();

  const venueOptions = (user?.venues || []).map(venue => ({
    label: venue?.directoryDisplayName || venue?.DirectoryDisplayName,
    value: venue?.organisationId || venue?.OrganisationId
  }));

  if(venueOptions.length == 0) {
    return;
  }

  const selectedVenueOption = selectedVenue
  ? {
      label: selectedVenue.directoryDisplayName || selectedVenue.label,
      value: selectedVenue.organisationId || selectedVenue.value
    }
  : user.isSuperAdmin ? null : venueOptions[0];

  const handleVenueChange = (event, selectedOption) => {
    if (selectedOption) {
      const { label, value } = selectedOption;
      setSelectedVenue({ label, value });
      navigate(`/dashboard/venue/${value}`);
    }
  }

  return (
    <Box sx={{ width: '100%', ml: 1 }}>
      <FormControl sx={{ width: { xs: '100%', md: 224 } }}>
        <Autocomplete
          options={venueOptions}
          id="select-venue"
          disableClearable
          getOptionLabel={(option) => option?.label || ''}
          isOptionEqualToValue={(option, val) => option?.value === val?.value}
          defaultValue={user.isSuperAdmin ? null : selectedVenueOption}
          onChange={handleVenueChange}
          value={selectedVenueOption}
          renderInput={(params) => (
            <TextField {...params} label="Select Venue" variant="standard" size="small" />
          )}
        />
      </FormControl>
    </Box>
  );
}
